import { useState, useEffect, useContext } from "react";
import { Table, Form, Input, Button, Modal, Space, message } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { AuthContext } from "../../contexts/AuthContext";

const REACT_APP_BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

const Branches = () => {
  const [makes, setMakes] = useState<any[]>([]);
  const [selectedMake, setSelectedBranch] = useState<string | null>(null);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState<"branch">("branch");
  const [form] = Form.useForm();
  const access = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const { user } = useContext(AuthContext);

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      const response = await fetch(`${REACT_APP_BASE_API_URL}/v1/branches`);
      const data = await response.json();
      setMakes(data);
    } catch (error) {
      message.error("Failed to fetch branches.");
    }
  };

  const showModal = (
    type: "branch",
    branchId: string | null = null,
    record: any = null
  ) => {
    setModalType(type);
    setSelectedBranch(branchId);
    setSelectedRecord(record);

    if (record) {
      form.setFieldsValue(record);
    } else {
      form.resetFields();
    }

    setIsModalVisible(true);
  };

  const handleAddOrEdit = async (values: any) => {
    try {
      let url = "";
      let method = "POST";

      if (modalType === "branch") {
        url = "/v1/branches";
        if (selectedRecord?._id) {
          url += `/${selectedRecord?._id}`;
          method = "PUT";
        }
      }

      const response = await fetch(`${REACT_APP_BASE_API_URL}${url}`, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });

      if (response.ok) {
        fetchBranches();
        message.success("Operation successful.");
        setIsModalVisible(false);
      } else {
        message.error("Operation failed.");
      }
    } catch (error) {
      message.error("Error occurred.");
    }
  };

  const handleDelete = async (
    type: string,
    id: string,
    branchId?: string,
    modelId?: string
  ) => {
    try {
      const url = `/v1/branches/${id}`;
      const response = await fetch(`${REACT_APP_BASE_API_URL}${url}`, {
        method: "DELETE",
      });
      if (response.ok) {
        fetchBranches();
        message.success("Deleted successfully.");
      } else {
        message.error("Failed to delete.");
      }
    } catch (error) {
      message.error("Error occurred while deleting.");
    }
  };

  const branchColumns: any = [
    {
      title: "Make Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => showModal("branch", null, record)}
          >
            Edit
          </Button>
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete("branch", record?._id)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between items-center border px-2">
          <div className="">
            <div className="font-bold capitalize text-lg">All Branches</div>
            <div className="text-gray-600 mb-1">Manage all branches</div>
          </div>

          <div className="flex">
            {access?.includes(user?.accessLevel) && (
              <button
                onClick={() => showModal("branch")}
                className="flex mx-2 justify-center items-center border px-4 h-8  bg-karimjee  hover:bg-karimjee-dark text-white shadow-sm"
              >
                + New Branch
              </button>
            )}
          </div>
        </div>

        <div className="border p-2 shadow-sm">
          <div className="">
            <Table
              dataSource={makes}
              columns={branchColumns}
              rowKey={(record) => record?._id || Math.random()}
            />

            <Modal
              title={
                modalType === "branch"
                  ? selectedRecord
                    ? "Edit  Branch"
                    : "Add  Branch"
                  : null
              }
              open={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              onOk={() => {
                form
                  .validateFields()
                  .then((values) => {
                    handleAddOrEdit(values);
                  })
                  .catch(() => {});
              }}
            >
              <Form
                form={form}
                layout="vertical"
                initialValues={selectedRecord || {}}
              >
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[
                    { required: true, message: "Please enter the name." },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: false, message: "Please enter the email." },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="mobile"
                  label="Mobile"
                  rules={[
                    { required: false, message: "Please enter the mobile." },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Form>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Branches;
